import { Theme as ITheme } from '@material-ui/core/styles';
import { none } from 'ramda';

const drawerWidth = 64;

export const styles = (theme: ITheme) => ({
    root: {
        zIndex: 1,
        top: 0,
        left: 0,
        borderRadius: '0px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            overflow: 'auto',
        },
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        '&.closed': {
            width: theme.spacing(9),
        },
    },
    drawerPaper: {
        width: drawerWidth,
        overflow: 'hidden',
        '&.closed': {
            width: theme.spacing(9),
        },
        borderRight: '1px solid #3F3F50',
    },
    toolbar: {
        width: '100%',
        maxWidth: '100%',
    },
    toolbarTitle: {
        display: 'flex',
        width: '100%',
        height: 'auto',
        justifyContent: 'center',
        position: 'relative',
        '& img': {
            cursor: 'pointer',
            padding: '16px 15px',
            width: '64px',
            height: 'auto',
        },
        '&::after': {
            content: "''",
            position: 'absolute',
            bottom: '0',
            left: '0',
            width: 'calc(100% - 20px)',
            height: '1px',
            backgroundColor: '#3F3F50',
            marginLeft: '12px',
        },
    },
    cardBody: {
        display: 'flex',
        padding: '0 15%',
        justifyContent: 'space-around',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-start',
        },
    },
    backIconWrapper: {
        width: 40,
        height: 40,
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(250,250,250, 0.2)',
        },
    },
    iconButton: {
        height: 'fit-content',
        borderRadius: 0,
        margin: '0px !important',
    },
    iconButtonActive: {
        height: 'fit-content',
        color: 'black',
        borderRadius: 0,
        margin: '0px !important',
    },
    iconTool: {
        width: '100%',
        height: '100%',
        objectFit: 'cover' as 'cover',
        borderRadius: 0,
        margin: '0px !important',
    },
    hideToolsAdjustmentDrawer: {
        position: 'absolute' as 'absolute',
        bottom: '0px',
        left: '44.7%',
        paddingBottom: '12px',
        cursor: 'pointer' as 'pointer',
        '& > .icon': {
            width: theme.spacing(3),
            height: theme.spacing(3),
            cursor: 'pointer',
        },
    },
    actionButtonsWrapper: {
        display: 'flex',
        gap: 8,
        '& .action-button': {
            border: '1px solid #585868',
            backgroundColor: '#3f3f50',
            color: '#ffffff',
            borderRadius: 8,
            textTransform: 'capitalize',
            height: 40,
            padding: '0 12px',
            fontSize: 14,
            FontWeight: 500,
        },
        '& .action-filled-button': {
            backgroundColor: '#DB2C29',
            border: '1px solid #DB2c29',
        },
    },
    actionButton: {
        cursor: 'pointer' as 'pointer',
        textTransform: 'uppercase' as 'uppercase',
        marginLeft: 8,
    },
    tooltip: {
        width: '50px',
        height: '50px',
        padding: '2px',
        margin: '10px',
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
        '&.headerTopMenu': {
            padding: 0,
            width: 'auto',
            height: 'auto',
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
            '& .MuiIconButton-label': {
                display: 'flex',
                gap: 8,
                border: 'solid 1px rgba(250, 250, 250, 0.2)',
                borderRadius: 8,
                height: 40,
                padding: '0 18px',
                alignItems: 'center',
                '& img': {
                    width: 15,
                    height: 'auto',
                },
                '& .label': {
                    fontSize: 14,
                    color: '#ffffff',
                },
            },
            '&:nth-child(1)': {
                '& .MuiIconButton-label': {
                    '& img': {
                        width: 17,
                    },
                },
            },
        },
    },
    cardBodyPadding: {
        padding: 0,
    },
    controls: {
        zIndex: 2,
        bottom: '175px',
        display: 'flex',
        position: 'absolute' as 'absolute',
        transition: 'margin .5s',
    },
    buttons: {
        background: 'rgba(255, 255, 255, .5)',
    },
    hideMenu: {
        marginTop: 'auto',
        textAlign: 'center' as 'center',
        minHeight: theme.spacing(5),
        '& > .icon': {
            width: theme.spacing(3),
            height: theme.spacing(3),
            cursor: 'pointer',
        },
    },
    toggleControls: {
        width: '75px',
        height: '75px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '0 50% 50% 0',
        background: 'rgba(255, 255, 255, .5)',
    },
    toggleControlsIcon: {
        marginLeft: '20%',
        fontSize: '3em',
    },
    keyframeLogo: {
        maxHeight: theme.spacing(4.5),
        cursor: 'pointer',
    },
    divider: {
        height: '40px',
        marginTop: '15px',
        backgroundColor: 'black',
        border: '0.5px solid white',
    },
    toolCheckmark: {
        position: 'absolute' as 'absolute',
        width: '25px',
        height: '25px',
        bottom: '-8px',
        right: '-5px',
    },
    slider: {
        color: '#EBEBEF',
        height: 2,
    },
    thumb: {
        '&:hover': { boxShadow: '0px 0px 0px 8px rgb(255 255 255 / 16%)' },
        '&:active': { boxShadow: '0px 0px 0px 12px rgb(255 255 255 / 16%)' },
        height: 20,
        width: 20,
        marginTop: -6,
    },
    track: {
        height: 8,
        borderRadius: 4,
        backgroundColor: '#DB2C29',
    },
    rail: {
        height: 8,
        borderRadius: 4,
        backgroundColor: '#ccc',
    },
    toolTypeContainer: {
        marginTop: '10px',
        marginBottom: '10px',
        display: 'flex',
        gap: 12,
    },
    iconButtonDrawer: {
        color: 'white',
        backgroundColor: '#282833',
        width: '83px',
        height: '26px',
        border: '1px solid #3F3F50',
        borderRadius: '17px',
        '&:hover': {
            // backgroundColor: 'white',
            border: '1px solid #3F3F50',
        },
    },
    iconButtonDrawerActive: {
        position: 'relative',
        // backgroundColor: 'white',
        '&::after': {
            content: "''",
            position: 'absolute',
            top: '-4px',
            left: '-4px',
            width: 'calc(100% + 8px)',
            height: 'calc(100% + 8px)',
            border: '2px solid #DB2C29',
            borderRadius: '19px',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            zIndex: '-1',
        },
    },
    toolTypeLine: {
        width: '100%',
        height: '100%',
        border: '1px solid white',
        backgroundColor: 'white',
        borderRadius: 2,
    },
    toolTypeDash: {
        width: '14px',
        height: '2px',
        backgroundColor: 'white',
        marginRight: '2px',
        marginLeft: '2px',
        borderRadius: 2,
    },
    toolTypeDashCommon: {
        width: '8px',
        height: '2px',
        backgroundColor: 'white',
        marginRight: '2px',
        marginLeft: '2px',
        borderRadius: 2,
    },
    recordinBtnWrapper: {
        width: '250px',
        backgroundColor: 'rgba(18, 18, 23, 0.7)',
        padding: 12,
        borderRadius: 16,
        position: 'absolute',
        // bottom: '94px',
        bottom: '80px',
        right: '7px',
        zIndex: 9000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .onlyForRecording': {
            width: 30,
            height: 30,
            padding: 0,
            '&:hover': {
                backgroundColor: 'transparent',
            },
            '& img': {},
        },
    },
    headerToolsListWrapper: {
        display: 'flex',
        padding: 0,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
    },
    licenceAndInfoDetails: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    },
    iconInfo: {
        width: '16px',
        height: '16px',
        objectFit: 'cover' as 'cover',
        borderRadius: 0,
    },
    tooltipWrapper: {
        backgroundColor: '#303030',
        color: '#fff',
        fontSize: 14,
        fontWeight: 300,
        borderRadius: 8,
        maxWidth: 220,
        whiteSpace: 'normal',
        padding: 8,
        zIndex: 999999999999,
    },
    arrow: {
        color: '#333 !important',
    },
});
